import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class StorageService {
  private storage: Storage;

  constructor() {
    // eslint-disable-next-line no-undef
    this.storage = localStorage;
  }

  getItem<T = any>(key: string, fallback?: T): T {
    let value: unknown = this.storage.getItem(key);

    // Esse try catch detalha o erro que acontece quando o json está em formáto inválido no
    // localStorage.
    try {
      value = JSON.parse(this.storage.getItem(key) ?? 'null');
    } catch (error) {
      throw new Error(`Error on getItem(${key}, ${fallback}): \n ${error}`);
    }

    value = value ?? fallback;
    if (value == null)
      throw new Error(
        `StorageService: key ${key} is not defined in local storage`
      );

    return value as T;
  }

  setItem(key: string, value: any) {
    this.storage.setItem(key, JSON.stringify(value));
  }

  removeItem(key: string) {
    this.storage.removeItem(key);
  }

  hasItem(key: string) {
    return this.storage.getItem(key) != null;
  }

  clear() {
    this.storage.clear();
  }

  get length() {
    return this.storage.length;
  }
}
